module.exports = __webpack_public_path__ + "static/media/tunisia_scooter_1.94e0642d.jpg";